import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const StartCard = ({ onStart }) => {
  const [isVisible, setIsVisible] = useState(false);
  const lineSpacing = 60;

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-[#2E2E2E]">
      <div className="relative h-screen flex flex-col items-center justify-center overflow-hidden">
        {/* Background Video */}
        <div className="absolute inset-0 w-full h-full flex items-center justify-center">
          <div className="w-full h-full relative overflow-hidden">
            <video 
              className="absolute w-full h-full object-cover"
              autoPlay 
              loop 
              muted 
              playsInline
            >
              <source src="https://processed.portal.soot.com/playground-static-assets/sootworld_AQPHYWccXI4S4k19yvndSIVyDckspe6SJsDYCRDyOlVEjzm9sOsAWdWrwqRbhdBecJfYL1yT5qx7TnnSEFaLzNFrghJS9Or0mZPKoxg.mp4" type="video/mp4" />
            </video>
          </div>
        </div>

        {/* Content Overlay */}
        <div 
          className="relative z-10 text-center px-8"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: `translateY(${isVisible ? 0 : 20}px)`,
            transition: 'opacity 1s cubic-bezier(0.16, 1, 0.3, 1), transform 1s cubic-bezier(0.16, 1, 0.3, 1)'
          }}
        >
          <svg className="w-full max-w-4xl mx-auto" viewBox="0 0 800 400">
            <text
              x="50%"
              y={120}
              dominantBaseline="middle"
              textAnchor="middle"
              style={{
                fontSize: '72px',
                fontFamily: 'ABC Diatype Rounded Medium',
                fill: '#ECFF0F',
                stroke: '#666',
                strokeWidth: '9px',
                paintOrder: 'stroke fill',
                opacity: isVisible ? 1 : 0,
                transition: 'opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.2s'
              }}
            >
              WELCOME TO
            </text>
            <text
              x="50%"
              y={120 + lineSpacing}
              dominantBaseline="middle"
              textAnchor="middle"
              style={{
                fontSize: '72px',
                fontFamily: 'ABC Diatype Rounded Medium',
                fill: '#ECFF0F',
                stroke: '#666',
                strokeWidth: '9px',
                paintOrder: 'stroke fill',
                opacity: isVisible ? 1 : 0,
                transition: 'opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.4s'
              }}
            >
              THE SOOT
            </text>
            <text
              x="50%"
              y={120 + (lineSpacing * 2)}
              dominantBaseline="middle"
              textAnchor="middle"
              style={{
                fontSize: '72px',
                fontFamily: 'ABC Diatype Rounded Medium',
                fill: '#ECFF0F',
                stroke: '#666',
                strokeWidth: '9px',
                paintOrder: 'stroke fill',
                opacity: isVisible ? 1 : 0,
                transition: 'opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.6s'
              }}
            >
              GAME
            </text>
          </svg>

          <motion.button 
            onClick={onStart}
            className="mt-12 px-8 py-3 bg-[#ECFF0F] text-black rounded-lg text-xl font-medium hover:bg-yellow-300 transition-colors"
            style={{ fontFamily: 'ABC Diatype Rounded Medium' }}
            whileHover={{ scale: 1.05 }}
            transition={{
              duration: 0.2,
              type: "spring",
              stiffness: 100,
              damping: 15
            }}
          >
            START GAME
          </motion.button>
          
          <p 
            className="text-2xl text-gray-200 max-w-2xl mx-auto mt-8"
            style={{ 
              fontFamily: 'ABC Diatype Rounded Medium',
              opacity: isVisible ? 1 : 0,
              transform: `translateY(${isVisible ? 0 : 20}px)`,
              transition: 'opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.8s, transform 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.8s'
            }}
          >
            Find your way through the SOOT world
          </p>
        </div>
      </div>
    </div>
  );
};

export default StartCard;